export const SUPPORTED_LANGS = [
    "en", // English
  //  "ru", // Russian
  //  "uk", // Ukrainian
 //   "es", // Spanish
 //   "pt", // Portuguese
 //   "de", // German
  //  "fr", // French
  //  "it", // Italian
  //  "nl", // Dutch
  //  "jp", // Japanese
  //  "kr", // Korean
  //  "cn", // Chinese
];


export function normalizeLang(raw) {
    const v = String(raw || "").toLowerCase().trim();
    if (!v) return null;

    // ru-RU -> ru, de-DE -> de
    const base = v.split("-")[0];

    // частые кейсы
    if (base === "ua") return "uk";

    return SUPPORTED_LANGS.includes(base) ? base : null;
}

export function getBrowserLang() {
    // navigator.languages обычно точнее чем navigator.language
    const list = (navigator.languages && navigator.languages.length)
        ? navigator.languages
        : [navigator.language];

    for (const l of list) {
        const n = normalizeLang(l);
        if (n) return n;
    }
    return "en";
}
